import { IFieldButton } from "@/@types/models/model";

const view: IFieldButton = {
  title: "",
  source: "view",
  tooltip: "buttons.view",
  ttoken: "",
  type: "button",
  icon: "open_in_new",
  action: "view",
  padding: "none",
  sort: false
};

const edit: IFieldButton = {
  title: "",
  source: "edit",
  tooltip: "buttons.edit",
  ttoken: "",
  type: "button",
  icon: "edit",
  action: "edit",
  padding: "none",
  sort: false
};

const remove: IFieldButton = {
  title: "",
  source: "remove",
  tooltip: "buttons.remove",
  ttoken: "",
  type: "button",
  icon: "delete_sweep",
  action: "remove",
  padding: "none",
  sort: false
}

const print: IFieldButton = {
  title: "",
  source: "print",
  tooltip: "buttons.print",
  ttoken: "",
  type: "button",
  icon: "print",
  action: "print",
  padding: "none",
  sort: false
}

const show_on_map: IFieldButton ={
  title: "",
  source: "show_on_map",
  ttoken: "",
  type: "button",
  icon: "explore",
  action: "show_on_map",
  padding: "none",
  sort: false
}

export const buttonFields = {
  view,
  edit,
  remove,
  print,
  show_on_map
};
